import dayjs from "dayjs"
import { FULL_DATE_FORMAT_EN } from "../../../adult/constants"
import { AnyObject } from "antd/es/_util/type"
import { t } from "i18next"

/**
 * This function returns total times between two dateTime i.e. startDateTime and endDateTime
 * But before you need to pass in valid date for proper data
 * */
export const getTotalTimeInSec =
  (date: string) => (startTime?: string, endTime?: string) => {
    if (!startTime || !endTime) {
      return 0
    }
    const startedDateTime = dayjs(`${date}${startTime}`)
    const endDateTime = dayjs(`${date}${endTime}`)

    return endDateTime.diff(startedDateTime, "second")
  }

export const getSumOfAllBreakTimes = (
  allBreakRec: AnyObject,
  date: string,
  status?: "OLD" | "NEW",
) => {
  let totalTime = 0
  const currentDate = dayjs(date).format(FULL_DATE_FORMAT_EN)
  const seconds = getTotalTimeInSec(currentDate)

  const startPrefix =
    status === "NEW" ? "new_break_start_time" : "break_start_time"
  const endPrefix = status === "NEW" ? "new_break_end_time" : "break_end_time"

  for (let i = 1; i <= 5; i++) {
    if (i === 1) {
      totalTime =
        totalTime +
        seconds(allBreakRec?.[startPrefix], allBreakRec?.[endPrefix])
    }
    if (i > 1) {
      totalTime =
        totalTime +
        seconds(
          allBreakRec?.[`${startPrefix}${i}`],
          allBreakRec?.[`${endPrefix}${i}`],
        )
    }
  }

  return totalTime
}

/**
 *
 * @param seconds in `number`
 * @returns time in hour: min format
 * `00hr 00mins`
 */
export const breakTimeInString = (
  seconds: number,
  format?: "SHORT_HAND" | "LONG_HAND",
) => {
  const prefix = seconds < 0 ? "-" : ""
  let totalSeconds = Math.abs(seconds)
  const totalHours = Math.floor(totalSeconds / (60 * 60)) // How many hours?
  totalSeconds = totalSeconds - totalHours * 60 * 60 // Pull those hours out of totalSeconds
  const totalMinutes = Math.floor(totalSeconds / 60) //With hours out this will retun minutes

  const formattedTotalBreakTime =
    format === "SHORT_HAND"
      ? "{{hour}}:{{minute}}"
      : t("{{hour}}hr {{minute}}mins", {
          hour: prefix + totalHours.toString().padStart(2, "0"),
          minute: totalMinutes.toString().padStart(2, "0"),
        })

  return formattedTotalBreakTime
}
